import { getCookies, setCookie } from 'lib/web/cookieUtils'

const CONTENT_TAG_ATTRIBUTION_COOKIE = 'le_content_tag_attr'
const ATTRIBUTION_TTL_SECONDS = 7 * 24 * 60 * 60

export interface ContentTagAttribution {
  id: string
  timestamp: number
}

export function setContentTagAttribution(id: string): void {
  setCookie(
    CONTENT_TAG_ATTRIBUTION_COOKIE,
    JSON.stringify({ id, timestamp: Date.now() }),
    ATTRIBUTION_TTL_SECONDS,
    '/',
    'Lax',
  )
}

export function getContentTagAttribution(): ContentTagAttribution | null {
  const raw = getCookies()[CONTENT_TAG_ATTRIBUTION_COOKIE]
  if (!raw) return null

  try {
    const attribution = JSON.parse(decodeURIComponent(raw))
    if (typeof attribution?.id !== 'string' || typeof attribution.timestamp !== 'number') return null
    return attribution
  } catch {
    return null
  }
}

export function clearContentTagAttribution(): void {
  setCookie(CONTENT_TAG_ATTRIBUTION_COOKIE, '', 0, '/', 'Lax')
}
